import CookieConsentComponent from './components/CookieConsent'
import NuxtCookieConsentComponent from './components/NuxtCookieConsent'
import ConsentStateHelper, * as events from './ConsentState'
import mountCookieConsentHelper from './mountCookieConsent'
import {
    readSettingsFromCookies as readSettingsFromCookiesHelper,
    readUserSettings as readUserSettingsHelper,
    readUserSettingsFromNuxtHeaders as readUserSettingsFromNuxtHeadersHelper,
} from './util/userSettings'


export const CookieConsent = CookieConsentComponent
export const NuxtCookieConsent = NuxtCookieConsentComponent
export const ConsentState = ConsentStateHelper

export const mountCookieConsent = mountCookieConsentHelper
export const readUserSettings = readUserSettingsHelper
export const readSettingsFromCookies = readSettingsFromCookiesHelper
export const readUserSettingsFromNuxtHeaders = readUserSettingsFromNuxtHeadersHelper

export const { EVENT_SHOW_LAYER } = events
export const { EVENT_CHANGE_LOCALE } = events
export const { EVENT_LOAD_LAYER } = events
export const { EVENT_UPDATE_LAYER } = events
export const { EVENT_CLOSE_LAYER } = events
